<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    document.addEventListener('contextmenu', function (e) {
      const tag = e.target.tagName.toLowerCase()
      if (tag === 'img' || tag === 'video' || tag === 'source' || tag === 'button') {
        e.preventDefault()
      }
    })
  }
}
</script>

<style>
*, *::before, *::after { box-sizing: border-box; }
html, body { margin: 0; padding: 0; }
img, video { -webkit-user-drag: none; user-select: none; -webkit-touch-callout: none; }
</style>
